import * as _ from "lodash";
import {getCDNImage} from "../utility";

export const checkIfPrefinedTags = (props) => {
    return (
        props.hasOwnProperty("predefinedTags") &&
        props.predefinedTags.hasOwnProperty("payload") &&
        props.predefinedTags.payload !== null
    )
}

export const getChannelPicture = (userDetails, default_value, $key = "channel_image_square") => {
    //console.log("getChannelPicture >> userDetails",userDetails)
    if (
        userDetails !== null &&
        userDetails.hasOwnProperty("broadcaster") &&
        userDetails.broadcaster !== null &&
        userDetails.broadcaster.length > 0 &&
        userDetails.broadcaster[0].hasOwnProperty($key) &&
        userDetails.broadcaster[0][$key] !== null
    ) {
        if($key === "channel_image_rectangle" || $key === "channel_image_square"){
            return getCDNImage(userDetails.broadcaster[0]["channel_image"]["bucket"],userDetails.broadcaster[0]["channel_image"]["key"],1000)
        }
        return userDetails.broadcaster[0][$key]
    } else {
        return default_value;
    }
}

export const getUserProfilePicture = (props, default_value) => {
    if (
        props !== null &&
        props.hasOwnProperty("profile_pic") &&
        props.profile_pic !==null
    ) {
        return props.profile_pic
    } else {
        return default_value;
    }
}

export const getChannelDescription = (props, default_value) => {
    if (
        props.hasOwnProperty("account_management") &&
        props.account_management.hasOwnProperty("userDetails") &&
        props.account_management.userDetails !== null &&
        props.account_management.userDetails.hasOwnProperty("broadcaster") &&
        props.account_management.userDetails.broadcaster !== null &&
        props.account_management.userDetails.broadcaster.length > 0 &&
        props.account_management.userDetails.broadcaster[0].hasOwnProperty("channel_description")
    ) {
        return props.account_management.userDetails.broadcaster[0].channel_description.length
    } else {
        return default_value;
    }
}

export const isProfileCreated = (props,isState) => {
    if(isState){
        return (
            props !== null &&
            props.hasOwnProperty("broadcaster") &&
            props.broadcaster !== null &&
            props.broadcaster.length > 0 &&
            props.broadcaster[0].hasOwnProperty("channel_description") &&
            props.broadcaster[0].channel_description !== null &&
            props.broadcaster[0].hasOwnProperty("channel_image_square") &&
            props.broadcaster[0].channel_image_square !== null &&
            props.broadcaster[0].hasOwnProperty("channel_image_rectangle") &&
            props.broadcaster[0].channel_image_rectangle !== null &&
            props.broadcaster[0].hasOwnProperty("tags") &&
            props.broadcaster[0].tags !== null &&
            props.broadcaster[0].tags.length > 0
        )
    }else{
        return (
            props.hasOwnProperty("account_management") &&
            props.account_management.hasOwnProperty("userDetails") &&
            props.account_management.userDetails !== null &&
            props.account_management.userDetails.hasOwnProperty("broadcaster") &&
            props.account_management.userDetails.broadcaster !== null &&
            props.account_management.userDetails.broadcaster.length > 0 &&
            props.account_management.userDetails.broadcaster[0].hasOwnProperty("channel_description") &&
            props.account_management.userDetails.broadcaster[0].channel_description !== null &&
            props.account_management.userDetails.broadcaster[0].hasOwnProperty("channel_image_square") &&
            props.account_management.userDetails.broadcaster[0].channel_image_square !== null &&
            props.account_management.userDetails.broadcaster[0].hasOwnProperty("channel_image_rectangle") &&
            props.account_management.userDetails.broadcaster[0].channel_image_rectangle !== null &&
            props.account_management.userDetails.broadcaster[0].hasOwnProperty("tags") &&
            props.account_management.userDetails.broadcaster[0].tags !== null &&
            props.account_management.userDetails.broadcaster[0].tags.length > 0
        )
    }
}

export const tagsObject = (id, ispredefined, name) => {
    return {
        id,
        ispredefined,
        name
    }
}

export const getTagsForAPI = (tags) => {
    let predefined = [], custom = [];
    _.map(tags, (tag) => {
        if (tag.ispredefined === "true") {
            predefined.push(parseInt(tag.id))
        } else {
            custom.push(tag.name)
        }
    })

    return JSON.stringify({
        predefined,
        custom
    })
}

export const getCanvasImage = (e,editor,callback) => {
    e.preventDefault();
    if (editor) {
        // This returns a HTMLCanvasElement, it can be made into a data URL or a blob,
        // drawn on another canvas, or added to the DOM.
        const canvas = editor.getImage().toDataURL();

        fetch(canvas)
            .then(res => res.blob())
            .then((blob) => {
                callback(blob);
            });
    }
}

export const getBlob= (canvas,callback) => {
    let base64Image = canvas.toDataURL('image/png', 1.0);
    fetch(base64Image)
        .then(res => res.blob())
        .then((blob) => {
            callback(blob);
        });
}

export const getBlobURL= (ref,canvas, fileName) => {
    return new Promise((resolve, reject) => {
        canvas.toBlob(blob => {
            if (!blob) {
                //reject(new Error('Canvas is empty'));
                console.error('Canvas is empty');
                return;
            }
            blob.name = fileName;
            window.URL.revokeObjectURL(ref.fileUrl);
            ref.fileUrl = window.URL.createObjectURL(blob);
            resolve(ref.fileUrl);
        }, 'image/png');
    });
}


export const clipstoreContentPriceList = () => {
    return [0.10,0.50,1,2,5,10,25,50,100];
}

export const clipstorePayPerMinutePriceList = () => {
    let perMin = [];
    for (let i = 0.10; i <= 5; i = i + 0.10) {
        perMin.push(i.toFixed(2));
    }
    return perMin;
}

export const priceList = () => {
    return [10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200,300,400,500];
}

export const isChecked = (name) => {
    if (document.getElementsByName(name).length > 0) {
        return document.getElementsByName(name)[0].checked
    } else {
        return false;
    }
}

export const checkBroadcasterAvialability = (userDetails) => {
    return userDetails && userDetails.broadcaster.length > 0 && userDetails.broadcaster[0].availability.length > 0
}